export const environment = {
    production: true,
    apiBaseUrl: "/api",
    simulatorCheckoutCancelUrl: 'http://dev.cestnow.com/simulator/cancel',
    simulatorCheckoutSuccessUrl: 'http://dev.cestnow.com/business-1/sucess',
    // checkoutCancelUrl: 'https://dev.cestnow.com/simulator/report/resume',
    // checkoutSuccessUrl: 'https://dev.cestnow.com/simulator/success',
    ebookCheckoutCancelUrl: 'https://dev.cestnow.com/cancel',
    ebookCheckoutSuccessUrl: 'https://dev.cestnow.com/ebook/success',
    stripe: 'sk_test_51O2BOVEujlwdtd0iepX0Q1XqeY2Xi2wZ5a1YXF5x3BeLXElNzOJLOa4na0iULnOdKlUenkP48O64q9P8aUlnspQu00V2lGFmMW',
    products: {
        simulatorbu01: {
            id: 'simulateur-bu-01',
            sessionId: 'simulateur-bu-01',
            ref: 'le-guide-ultime',
            pixel: '933734658480919',
            accessToken: 'EAAXOKS1jm9wBO98x9sZBvP7WDiFyfNHpUgCihTwSsNmZAWqxWaAI4iZCJhUHXkZBVrOBsrsR1xhZC698kGZBoA0JBr83XRq7OfaGFXZCqWLic5h5RrZCHwhAyVdzhuZAmZAqzt4lL0Fajf4vdufMk4ft7poNjscMGkIilnQ3d9DZAEIF5zxDGcMgNOSHnlVuSPcnO9YqgZDZD',
            devise: 'EUR',
            product: {
                id: 'prod_Qzb3ymAgL3nKj8',
                price: [
                    {
                        amount: 197,
                        devise: 'EUR',
                        id: 'price_1QPWYSEujlwdtd0ip5N0ViSV'
                    },
                    {
                        amount: 147,
                        devise: 'EUR',
                        id: 'price_1Q7brGEujlwdtd0itrNqVVZR'
                    },
                    {
                        amount: 97,
                        devise: 'EUR',
                        id: 'price_1Q7bsvEujlwdtd0ij9Q0G17O'
                    },
                    {
                        amount: 27,
                        devise: 'EUR',
                        id: 'price_1Q7bthEujlwdtd0iHqpodLqW'
                    },
                ]
            }
        },
        ebooks: {
            ebook01: {
                id: 'ebook01',
                ref: 'comment-elever-l-amour-propre-et-guérir-l-esprit-le-corps-et-l-ame',
                pixel: '1111397830067390',
                accessToken: 'EAAXOKS1jm9wBO98x9sZBvP7WDiFyfNHpUgCihTwSsNmZAWqxWaAI4iZCJhUHXkZBVrOBsrsR1xhZC698kGZBoA0JBr83XRq7OfaGFXZCqWLic5h5RrZCHwhAyVdzhuZAmZAqzt4lL0Fajf4vdufMk4ft7poNjscMGkIilnQ3d9DZAEIF5zxDGcMgNOSHnlVuSPcnO9YqgZDZD',
                price: 0,
                devise: 'EUR',
                product: {
                    id: 'prod_QzgSH60WOXwB8X',
                    price: [
                        {
                            amount: 27,
                            devise: '€',
                            id: 'price_1QUa7JEujlwdtd0ieHsbiuRl'
                        },
                        {
                            amount: 17,
                            devise: '€',
                            id: 'price_1Q7h5jEujlwdtd0i8pmIliyd'
                        },
                        {
                            amount: 12,
                            devise: '€',
                            id: 'price_1QUlb4Eujlwdtd0isDKbRP7O'
                        },
                        {
                            amount: 7.97,
                            devise: '€',
                            id: 'price_1Q7h6bEujlwdtd0iy32xagX8'
                        },
                    ]
                }
            },
            ebook02: {
                id: 'ebook02',
                ref: 'le-guide-ultime',
                pixel: '933734658480919',
                accessToken: 'EAAXOKS1jm9wBO98x9sZBvP7WDiFyfNHpUgCihTwSsNmZAWqxWaAI4iZCJhUHXkZBVrOBsrsR1xhZC698kGZBoA0JBr83XRq7OfaGFXZCqWLic5h5RrZCHwhAyVdzhuZAmZAqzt4lL0Fajf4vdufMk4ft7poNjscMGkIilnQ3d9DZAEIF5zxDGcMgNOSHnlVuSPcnO9YqgZDZD',
                price: 0,
                devise: 'EUR',
                product: {
                    id: 'prod_Qzb3ymAgL3nKj8',
                    price: [
                        {
                            amount: 197,
                            devise: 'EUR',
                            id: 'price_1QPWYSEujlwdtd0ip5N0ViSV'
                        },
                        {
                            amount: 147,
                            devise: 'EUR',
                            id: 'price_1Q7brGEujlwdtd0itrNqVVZR'
                        },
                        {
                            amount: 97,
                            devise: 'EUR',
                            id: 'price_1Q7bsvEujlwdtd0ij9Q0G17O'
                        },
                        {
                            amount: 27,
                            devise: 'EUR',
                            id: 'price_1Q7bthEujlwdtd0iHqpodLqW'
                        },
                    ]
                }
            },
            ebook03: {
                id: 'ebook03',
                ref: 'guide-faceless-ia',
                pixel: '933734658480919',
                accessToken: 'EAAXOKS1jm9wBO98x9sZBvP7WDiFyfNHpUgCihTwSsNmZAWqxWaAI4iZCJhUHXkZBVrOBsrsR1xhZC698kGZBoA0JBr83XRq7OfaGFXZCqWLic5h5RrZCHwhAyVdzhuZAmZAqzt4lL0Fajf4vdufMk4ft7poNjscMGkIilnQ3d9DZAEIF5zxDGcMgNOSHnlVuSPcnO9YqgZDZD',
                price: 0,
                devise: 'EUR',
                product: {
                    id: 'prod_Qzg0HHHFY8zSHZ',
                    price: [
                        {
                            amount: 197,
                            devise: '€',
                            id: 'price_1QUB0ZEujlwdtd0itTh4uCXL'
                        },
                        {
                            amount: 97,
                            devise: '€',
                            id: 'price_1Q7gksEujlwdtd0i0tAIuKLS'
                        },
                        {
                            amount: 27,
                            devise: '€',
                            id: 'price_1Q7gjWEujlwdtd0iO1AtO50d'
                        },
                        {
                            amount: 17.97,
                            devise: '€',
                            id: 'price_1Q7ge9Eujlwdtd0iSt4hUj14'
                        },
                    ]
                }
            },
            ebook04: {
                id: 'ebook04',
                ref: 'comment-elever-l-amour-propre-et-guérir-l-esprit-le-corps-et-l-ame',
                pixel: '1111397830067390',
                accessToken: 'EAAXOKS1jm9wBO98x9sZBvP7WDiFyfNHpUgCihTwSsNmZAWqxWaAI4iZCJhUHXkZBVrOBsrsR1xhZC698kGZBoA0JBr83XRq7OfaGFXZCqWLic5h5RrZCHwhAyVdzhuZAmZAqzt4lL0Fajf4vdufMk4ft7poNjscMGkIilnQ3d9DZAEIF5zxDGcMgNOSHnlVuSPcnO9YqgZDZD',
                price: 0,
                devise: 'EUR',
                product: {
                    id: 'prod_Px1MFM1pBTfMi0',
                    price: [
                        {
                            amount: 27,
                            devise: '€',
                            id: 'price_1QUa7JEujlwdtd0ieHsbiuRl'
                        },
                        {
                            amount: 17,
                            devise: '€',
                            id: 'price_1Q7h5jEujlwdtd0i8pmIliyd'
                        },
                        {
                            amount: 12,
                            devise: '€',
                            id: 'price_1QUlb4Eujlwdtd0isDKbRP7O'
                        },
                        {
                            amount: 7.97,
                            devise: '€',
                            id: 'price_1Q7h6bEujlwdtd0iy32xagX8'
                        },
                    ]
                }
            },
            ebook05: {
                id: 'guide-import-export-ebook-05',
                sessionId: 'guide-import-export-ebook-05',
                ref: 'guide-import-export',
            },
            ebook06: {
                id: 'ebook06',
                sessionId: 'la-planche-d-ambiance',
                ref: 'la-planche-d-ambiance',
                pixel: '1685809902342490',
                accessToken: 'EAAbhuAZCf3ZCkBO1qhR7iqQ5giYVvulXtPIubQdOW636MZCRCOZAI9RZCxGKssGWunYeecbSH6tTEUZBIxmKaJNx0qfyZCC1CC0r6LP6XLH7PATCO0CUk4LxXeu7zaOil1Fr3mMX3Pp2Fov29IWXKRtZBY4NZBQcNrKJIvnQellFY8feDsUoyLQm0bHq63Cf53VLZAVQZDZD',
                price: 0,
                devise: 'EUR',
                product: {
                    id: 'prod_RaHJP3VdpImBpH',
                    price: [
                        {
                            amount: 27,
                            devise: 'EUR',
                            id: 'price_1Qh6lEEujlwdtd0i4woesKsq'
                        },
                        {
                            amount: 17,
                            devise: 'EUR',
                            id: 'price_1Qh6jBEujlwdtd0ij9czHS8A'
                        },                      
                    ]
                }
            }
        }
    }
};


